export class ConfirmEmitDropoffDto {
    accept: boolean;
    responseType: string;

    constructor() {
        this.accept = false;
        this.responseType = '';
    }
}
